import { Comunas, Departamentos, Municipio, Pais } from "../../models/LocationsModels/locations.models";
import { BaseLocationService } from "../base/baseApiLocation";

export class LocationService extends BaseLocationService {

  async obtenerPaises() : Promise<Pais[]> {
    try {
      const { data } = await this.axiosClient.get(`/locations/obtenerPaises`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerPaises with stack: ${error}`);
    }
  }


  async obtenerDepartamentos() : Promise<Departamentos[]> {
    try {
      const { data } = await this.axiosClient.get(`/locations/obtenerDepartamentos`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerDepartamentos with stack: ${error}`);
    }
  }

  async obtenerMunicipios( id_departamento: any ) : Promise<Municipio[]>{
    try {
      let { data } = await this.axiosClient.get(`/locations/obtenerMunicipios/${id_departamento}`);
      return data.data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerBarrios with stack: ${error}`);
    }
  }

  async obtenerComunas() : Promise<Comunas[]> {
    try {
      let { data } = await this.axiosClient.get(`/locations/obtenerComunas`);
      return data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerCiudades with stack: ${error}`);
    }
  }
  
  async obtenerBarrios( id_comuna: any ) {
    try {
      let { data } = await this.axiosClient.get(`/locations/obtenerBarrios/${id_comuna}`);
      return data.data;
    } catch (error) {
      throw new Error(`An unhandled exception in obtenerBarrios with stack: ${error}`);
    }
  }


}

export default new LocationService();
